// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Circle } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconCircle(props: any) {
    return <IconBase icon={Circle} {...props} />
  }

  export default IconCircle
  